<template>
  <div class="container">
    <div class="bgcF">
      <div class="nav-tab">
        <img src="../../assets/images/arrow.png" alt="" />
        <div>您的当前位置是：下载中心</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="nav-titie">
            下载中心
            <div class="list-box">
              <div
                v-for="(item, index) in list"
                :key="index"
                class="sidebar"
                :class="{ active: selectedItem == index }"
                @click="selectItem(index)"
              >
                {{ item }}
              </div>
              <img src="../../assets/images/nav-img.png" alt="" />
            </div>
          </div>
        </div>
        <div class="right">
          <div v-show="selectedItem>=0" class="box">
            <!-- <div v-show="selectedItem === '工具软件'" class="detachment-leader">
              1
            </div> -->
            <div class="location">
              <div style="display: flex; flex-wrap: wrap; height: 100px">
                <div class="downItem" v-for="(item, index) in teamList" :key="index">
                  <div class="title">{{item.name}}</div>
                  <div class="info">{{item.content}}</div>
                  <div class="downLoad ">
                    <img class="hover-underline" src="../../assets/images/dowAp.png" alt="">
                    <span class="hover-underline" @click="downLoad(item.url)">下载</span>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="page-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchFrom.pageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="searchFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
            <!-- <div v-if="selectedItem == '1'" class="location">
              <div style="display: flex; flex-wrap: wrap; height: 100px">
                <div class="downItem" v-for="(item, index) in 10" :key="index">
                  <div class="title">这是软件名称</div>
                  <div class="info">这是软件名称</div>
                  <div class="downLoad ">
                    <img class="hover-underline" src="../../assets/images/dowAp.png" alt="">
                    <span class="hover-underline">下载</span>
                  </div>
                </div>
                
              </div>
            </div>
            <div v-if="selectedItem == '2'" class="location">
              <div style="display: flex; flex-wrap: wrap; height: 100px">
                <div class="downItem" v-for="(item, index) in 10" :key="index">
                  <div class="title">这是软件名称</div>
                  <div class="info">这是软件名称</div>
                  <div class="downLoad ">
                    <img class="hover-underline" src="../../assets/images/dowAp.png" alt="">
                    <span class="hover-underline">下载</span>
                  </div>
                </div>
                
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="bottom-info">
        <div class="bottom-box">
          <div>
            <span class="hover-underline" @click="tps(0)">首页</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(1)">地理位置</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(2)">联系我们</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(3)">技术支持</span>
          </div>
          <div>主办单位：池州市消防救援支队</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listOrgan, listspecial, listTeam } from "@/api/index";
import { listUrl } from "@/api/softwareDownload";
export default {
  data() {
    return {
      // , "机关简介"
      list: ["杀毒软件", "工具软件", "文件资料"],
      selectedItem: "0",
      leaderList: [],
      text: "",
      map: null,
      team: "",
      searchFrom: {
        pageNum: 1,
        pageSize: 8,
      },
      oragenFrom: {},
      maker: null,
      teamList: [],
      total: 0,
    };
  },
  created() {
    this.getlistUrl()
  },
  methods: {
    tps(type){
      let url
      if(type == 1){
         url = `/?organization=地理位置`;
      }else if(type == 2){
         url = `/?call=1`;
      }else if(type == 3){
         url = `http://www.ahqmkeji.com/aboutus`;
      }else{
         url = `/`;
      }
      window.open(url, "_blank");
    },
    handleSizeChange(val) {
      this.searchFrom.pageSize = val;
      this.getlistUrl();
    },
    handleCurrentChange(val) {
      this.searchFrom.pageNum = val;
      this.getlistUrl();
    },
    downLoad(url){
      // window.location.href = url;
      window.open(url);
    },
    async getlistUrl(){
      this.searchFrom.type = this.selectedItem;
      const { data:res } = await listUrl(this.searchFrom);
      if(res.code === 200){
        this.teamList = res.data.list;
        this.total = res.data.total;
        console.log(this.teamList);
        
      }
    },
    selectItem(item) {
      this.selectedItem = item;
      this.getlistUrl()
    },
  },
};
</script>

<style scoped lang="scss">
  .page-container{
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 10px;
  }
#map {
  width: 100%;
  height: 398px;
}
.container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.bgcF {
  width: 1120px;
  background-color: #fff;
}
.dispF {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  .lingdao {
    width: 64px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}
.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;

  img {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }

  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}

.content {
  width: 1120px;
  margin: 0;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .left {
    .nav-titie {
      position: relative;
      width: 200px;
      height: 236px;
      background: #0e67ab;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      padding: 12px;
      box-sizing: border-box;

      .list-box {
        position: absolute;
        top: 53px;
        left: 12px;
        width: 195px;
        background-color: #fff;

        .sidebar {
          width: 188px;
          height: 56px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          line-height: 56px;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .sidebar.active {
          background-color: #d4ac62;
          color: #fff;
        }

        img {
          width: 168px;
          height: 100px;
          margin-top: 16px;
        }
      }
    }
  }
  .right {
    overflow: hidden; /* 隐藏超出窗口高度的内容 */
    width: 880px;
    // height: 633px;
    background: #ffffff;
    border: 1px solid #d6d8d7;
    margin-left: 40px;
    position: relative;

    .box {
      width: 840px;
      // height: 633px;
      // overflow-y: auto;
      // padding: 40px 60px 0 60px;
    }
    /* 样式化滚动条 */
    .box::-webkit-scrollbar {
      width: 5px; /* 滚动条的宽度 */
    }

    /* 滚动条背景 */
    .box::-webkit-scrollbar-track {
      background-color: #f1f1f1; /* 滚动条轨道的颜色 */
    }

    /* 滚动条滑块 */
    .box::-webkit-scrollbar-thumb {
      background-color: #888; /* 滚动条滑块的颜色 */
      border-radius: 5px; /* 滚动条滑块的圆角 */
    }

    /* 鼠标悬停时滚动条滑块 */
    .box::-webkit-scrollbar-thumb:hover {
      background-color: #555; /* 鼠标悬停时滚动条滑块的颜色 */
    }

    /* 点击滚动条轨道时的空白区域 */
    .box::-webkit-scrollbar-track-piece {
      background-color: #ddd; /* 点击滚动条轨道时的空白区域颜色 */
    }

    /* 触摸设备上的滚动条 */
    .box::-webkit-scrollbar-thumb:vertical {
      background-color: #666; /* 竖直滚动条滑块的颜色 */
    }

    .box::-webkit-scrollbar-thumb:horizontal {
      background-color: #666; /* 水平滚动条滑块的颜色 */
    }

    /* 滚动条角落 */
    .box::-webkit-scrollbar-corner {
      background-color: #f1f1f1; /* 滚动条角落的颜色 */
    }

    .detachment-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 60px 0 60px;
      height: 833px;
      img {
        width: 140px;
        height: 176px;
      }

      .name-detail {
        margin-top: 10px;
        width: 140px;
        text-align: center;
      }
    }

    // .detachment-leader > div:nth-child(2),
    // .detachment-leader > div:nth-child(5) {
    //   margin-left: 90px;
    //   margin-right: 90px;
    // }
    .intro {
      height: 633px;
      padding-top: 40px;
      background-color: #fff;
      #text {
        display: inline-block;
      }
    }
    .location {
      height: 633px;
      padding: 40px;
      display: flex;
      // flex-wrap: wrap;
      .downItem {
        margin: 20px;
        width: 311px;
        height: 72px;
        padding: 14px;
        background: #ffffff;
        box-shadow: 0px 0px 12px 1px rgba(153, 153, 153, 0.2);
        border-radius: 8px 8px 8px 8px;
        .title {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
        .info {
          margin-top: 6px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
        .downLoad {
          margin-top: 6px;
          display: flex;
          justify-content: flex-end;
          img {
            width: 14px;
            height: 14px;
            margin-top: 4px;
            margin-right: 6px;
            vertical-align:middle
          }
        }
      }
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: linear-gradient( 180deg, #0E67AB 0%, #073456 100%);
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
